import { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import Loader from "shared/components/Loader";

const YearMonthFilters = lazy(() =>
  import("../pages/FiltersSidebar/YearMonthFilters")
);

const HomeFiltersPopups               = lazy(() => import("../pages/Home/filterspopups"));
const AuctionsFiltersPopups           = lazy(() => import("../pages/Auctions/filterspopups"));
const AnalyticTotalFiltersPopups      = lazy(() => import("../pages/AnalyticTotal/filterspopups"));
const AnalysisSSPFiltersPopups        = lazy(() => import("../pages/AnalysisSSP/filterspopups"));
const AnalysisFiltersPopups           = lazy(() => import("../pages/Analysis/filterspopups"));
const CompetitorAnalysisFiltersPopups = lazy(() => import("../pages/CompetitorAnalysis/filterspopups"));
const IndicatorDynamicFiltersPopups   = lazy(() => import("../pages/IndicatorDynamic/filterspopups"));
const PeriodMonitoringFiltersPopups   = lazy(() => import("../pages/PeriodMonitoring/filterspopups"));
const PeriodMonitoringSSPFiltersPopups= lazy(() => import("../pages/PeriodMonitoringSSP/filterspopups"));
const ParticipantsFiltersPopups       = lazy(() => import("../pages/Participants/filterspopups"));
const ParticipantsCardFiltersPopups   = lazy(() => import("../pages/ParticipantsCard/filterspopups"));
const ContractsFiltersPopups          = lazy(() => import("../pages/Contracts/filterspopups"));
const QuestionsFiltersPopups          = lazy(() => import("../pages/Questions/filterspopups"));
const SitesFiltersPopups              = lazy(() => import("../pages/Sites/filterspopups"));
const OrganizersFiltersPopups         = lazy(() => import("../pages/Organizers/filterspopups"));
const OrganizerCardFiltersPopups      = lazy(() => import("../pages/OrganizerCard/filterspopups"));
const GeographyFiltersPopups          = lazy(() => import("../pages/Geography/filterspopups"));
const BestResultsFiltersPopups        = lazy(() => import("../pages/BestResults/filterspopups"));
const IncomeDynamicsFiltersPopups     = lazy(() => import("../pages/IncomeDynamics/filterspopups"));
const LeaseRegistryFiltersPopups      = lazy(() => import("../pages/LeaseRegistry/filterspopups"));
const LeaseContractsFiltersPopups     = lazy(() => import("../pages/LeaseContracts/filterspopups"));
const ProcedureTypeFiltersPopups      = lazy(() => import("../pages/ProcedureType/filterspopups"));
const DirectionAnalysisFiltersPopups  = lazy(() => import("../pages/DirectionAnalysis/filterspopups"));
const AssetsFiltersPopups             = lazy(() => import("../pages/Assets/filterspopups"));
const AssetsSSPFiltersPopups          = lazy(() => import("../pages/AssetsSSP/filterspopups"));
const AssetItemsFiltersPopups         = lazy(() => import("../pages/AssetItems/filterspopups"));
const OrganizerResultsFiltersPopups   = lazy(() => import("../pages/OrganizerResults/filterspopups"));
const DisqualifiedBillingFiltersPopups= lazy(() => import("../pages/DisqualifiedBilling/filterspopups"));

const HomeFilters               = lazy(() => import("../pages/Home/filters"));
const AuctionsFilters           = lazy(() => import("../pages/Auctions/filters"));
const AnalyticTotalFilters      = lazy(() => import("../pages/AnalyticTotal/filters"));
const AnalysisSSPFilters        = lazy(() => import("../pages/AnalysisSSP/filters"));
const AnalysisFilters           = lazy(() => import("../pages/Analysis/filters"));
const CompetitorAnalysisFilters = lazy(() => import("../pages/CompetitorAnalysis/filters"));
const IndicatorDynamicFilters   = lazy(() => import("../pages/IndicatorDynamic/filters"));
const PeriodMonitoringFilters   = lazy(() => import("../pages/PeriodMonitoring/filters"));
const PeriodMonitoringSSPFilters= lazy(() => import("../pages/PeriodMonitoringSSP/filters"));
const ParticipantsFilters       = lazy(() => import("../pages/Participants/filters"));
const ParticipantsCardFilters   = lazy(() => import("../pages/ParticipantsCard/filters"));
const ContractsFilters          = lazy(() => import("../pages/Contracts/filters"));
const QuestionsFilters          = lazy(() => import("../pages/Questions/filters"));
const SitesFilters              = lazy(() => import("../pages/Sites/filters"));
const OrganizersFilters         = lazy(() => import("../pages/Organizers/filters"));
const OrganizerCardFilters      = lazy(() => import("../pages/OrganizerCard/filters"));
const GeographyFilters          = lazy(() => import("../pages/Geography/filters"));
const BestResultsFilters        = lazy(() => import("../pages/BestResults/filters"));
const IncomeDynamicsFilters     = lazy(() => import("../pages/IncomeDynamics/filters"));
const LeaseRegistryFilters      = lazy(() => import("../pages/LeaseRegistry/filters"));
const LeaseContractsFilters     = lazy(() => import("../pages/LeaseContracts/filters"));
const ProcedureTypeFilters      = lazy(() => import("../pages/ProcedureType/filters"));
const DirectionAnalysisFilters  = lazy(() => import("../pages/DirectionAnalysis/filters"));
const OrganizerResultsFilters   = lazy(() => import("../pages/OrganizerResults/filters"));
const DisqualifiedBillingFilters= lazy(() => import("../pages/DisqualifiedBilling/filters"));

export default function SideBar() {
  return (
    <Suspense fallback={<Loader />}>
      <div className="p-2">

        {/* ── 1) “Popup” filters BEFORE YearMonthFilters ── */}
        <Routes>
          <Route path="/" element={<HomeFiltersPopups />} />
          <Route path="/auctions" element={<AuctionsFiltersPopups />} />
          <Route path="/analyticTotal" element={<AnalyticTotalFiltersPopups />} />
          <Route path="/analysisSSP" element={<AnalysisSSPFiltersPopups />} />
          <Route path="/analysis" element={<AnalysisFiltersPopups />} />
          <Route path="/competitorAnalysis" element={<CompetitorAnalysisFiltersPopups />} />
          <Route path="/indicatorDynamic" element={<IndicatorDynamicFiltersPopups />} />
          <Route path="/periodMonitoring" element={<PeriodMonitoringFiltersPopups />} />
          <Route path="/periodMonitoringSSP" element={<PeriodMonitoringSSPFiltersPopups />} />
          <Route path="/participants" element={<ParticipantsFiltersPopups />} />
          <Route path="/participantsCard" element={<ParticipantsCardFiltersPopups />} />
          <Route path="/contracts" element={<ContractsFiltersPopups />} />
          <Route path="/questions" element={<QuestionsFiltersPopups />} />
          <Route path="/sites" element={<SitesFiltersPopups />} />
          <Route path="/organizers" element={<OrganizersFiltersPopups />} />
          <Route path="/organizerCard" element={<OrganizerCardFiltersPopups />} />
          <Route path="/geography" element={<GeographyFiltersPopups />} />
          <Route path="/bestResults" element={<BestResultsFiltersPopups />} />
          <Route path="/incomeDynamics" element={<IncomeDynamicsFiltersPopups />} />
          <Route path="/leaseRegistry" element={<LeaseRegistryFiltersPopups />} />
          <Route path="/leaseContracts" element={<LeaseContractsFiltersPopups />} />
          <Route path="/procedureType" element={<ProcedureTypeFiltersPopups />} />
          <Route path="/directionAnalysis" element={<DirectionAnalysisFiltersPopups />} />
          <Route path="/assets" element={<AssetsFiltersPopups />} />
          <Route path="/assetsSSP" element={<AssetsSSPFiltersPopups />} />
          <Route path="/assetItems" element={<AssetItemsFiltersPopups />} />
          <Route path="/organizerResults" element={<OrganizerResultsFiltersPopups />} />
          <Route path="/disqualifiedBilling" element={<DisqualifiedBillingFiltersPopups />} />
        </Routes>

        {/* ── 2) Year‐Month Selector (always visible) ── */}
        <YearMonthFilters />

        {/* ── 3) “Normal” filters AFTER YearMonthFilters ── */}
        <Routes>
          <Route path="/" element={<HomeFilters />} />
          <Route path="/auctions" element={<AuctionsFilters />} />
          <Route path="/analyticTotal" element={<AnalyticTotalFilters />} />
          <Route path="/analysisSSP" element={<AnalysisSSPFilters />} />
          <Route path="/analysis" element={<AnalysisFilters />} />
          <Route path="/competitorAnalysis" element={<CompetitorAnalysisFilters />} />
          <Route path="/indicatorDynamic" element={<IndicatorDynamicFilters />} />
          <Route path="/periodMonitoring" element={<PeriodMonitoringFilters />} />
          <Route path="/periodMonitoringSSP" element={<PeriodMonitoringSSPFilters />} />
          <Route path="/participants" element={<ParticipantsFilters />} />
          <Route path="/participantsCard" element={<ParticipantsCardFilters />} />
          <Route path="/contracts" element={<ContractsFilters />} />
          <Route path="/questions" element={<QuestionsFilters />} />
          <Route path="/sites" element={<SitesFilters />} />
          <Route path="/organizers" element={<OrganizersFilters />} />
          <Route path="/organizerCard" element={<OrganizerCardFilters />} />
          <Route path="/geography" element={<GeographyFilters />} />
          <Route path="/bestResults" element={<BestResultsFilters />} />
          <Route path="/incomeDynamics" element={<IncomeDynamicsFilters />} />
          <Route path="/leaseRegistry" element={<LeaseRegistryFilters />} />
          <Route path="/leaseContracts" element={<LeaseContractsFilters />} />
          <Route path="/procedureType" element={<ProcedureTypeFilters />} />
          <Route path="/directionAnalysis" element={<DirectionAnalysisFilters />} />
          <Route path="/organizerResults" element={<OrganizerResultsFilters />} />
          <Route path="/disqualifiedBilling" element={<DisqualifiedBillingFilters />} />
        </Routes>
      </div>
    </Suspense>
  );
}
